import type { Feature } from '@luna/gatekeeper';

export const cardMigrationExternal: Feature = {
    enabled: false,
    _description: 'Enables card migration section under services',
};
